/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, graphql, useStaticQuery } from 'gatsby'
import styled, { css } from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import 'react-dropdown/style.css'
import { colors, device, pageWidth } from '../../styles/config'
import { getFullDate } from '../../utils/time'

import FormCalendar from './FormCalendar'
import FormRooms from './FormRooms'
import Dropdown from './FormDropdown'
import Checkbox from './Checkbox'
import Button from '../Button'

const Container = styled.div`
  font-size: 0.875rem;
  line-height: 1.85;
  letter-spacing: 0.53px;
  max-width: ${ pageWidth };
  margin: 0 auto;

  @media ${ device.md } {
    font-size: 0.75rem;
  }

  @media ${ device.sm } {
    font-size: 0.875rem;
  }
`

const Instructions = styled(Col)`
  margin-top: 3.125rem;
`

const GroupHeader = styled(Col)`
  margin-top: 3.125rem;
  margin-bottom: 1rem;
  font-weight: bold;
`

const GroupHeaderNote = styled(Col)`
  margin-bottom: 1rem;
`

const ErrorMessage = styled.div`
  font-size: 10px;
  color: red;
  position: absolute;
`

const TextInput = styled.input`
  width: 100%;
  margin:0;
  padding: 0;
  display:inline-block;
  vertical-align:middle;
  white-space:normal;
  background:none;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  height: 2.1875rem;
  border-radius: 0;
  color: ${ colors.primary };
  line-height: normal;
  border: 1px solid ${ colors.primary };

  ${ props => props.fieldRequired && css`
    border: 1px solid red;

    &:only-child {
      border: 1px solid ${ colors.primary };
    }
  ` }

  &:focus {
    outline: 0;
  }

  &:-webkit-autofill {
    background: none !important;
    color: ${ colors.primary } !important;
  }
`

const InputGroup = styled(Row)`
  ${ Col } {
    @media ${ device.sm } {
      margin-bottom: ${ props => !props.horizontal && '1.15rem' };

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`

const VerticalInputGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .Dropdown-menu {
    /* padding-right: 0.9375rem;
    width: initial; */
  }

  > div {
    width: 50%;
    margin-bottom: 1.15rem;
    padding-right: 0.9375rem;

    &:last-child {
      margin-bottom: 0;
    }

    @media ${ device.sm } {
      width: 100%;
      padding-right: 0;
    }
  }

  > ul {
    position: absolute;
    right: 0;
    width: 50%;
    padding-left: 0.9375rem;

    @media ${ device.sm } {
      padding-left: 0;
      width: 100%;
      position: initial;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      > li {
        /* width: 50%; */
        /* flex-basis: 50%; */
        margin-bottom: 1.15rem;

        &:last-child {
          position: relative;
          left: 1px;
        }
      }
    }
  }
`

const VerticalGroupHeader = styled.div`
  margin-top: 3.125rem;
  margin-bottom: 1rem;
  font-weight: bold;
`

const DateInput = styled.div`
  width: 100%;
  line-height: 2.4;
  color: ${ colors.primary };
  position: relative;
  height: 35px;
  position: relative;

  @media ${ device.sm } {
    height: 31px;
  }
`

const CalendarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
  opacity: ${ props => props.calendarVisible ? '1' : '0' };
  visibility: ${ props => props.calendarVisible ? 'visible' : 'hidden' };
`

const CalendarContainerInner = styled.div`
    width: 370px;
    z-index: 1;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(50,61,116,0.8);
`

const DetailsContainer = styled(Col)`
  display: flex !important;
  flex-direction: column;
`

const Details = styled.textarea`
  width: 100% !important;
  height: 100% !important;
  outline: none;
  resize: none;
  border-radius: 0 !important;
  border: 1px solid ${ colors.primary };
  color: ${ colors.primary };
  padding: 0.75rem 1rem;
`

const FormFooter = styled(Row)`
  margin-top: 3.75rem;

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
`

const RequiredField = styled.div`
  margin-top: 1rem;
  margin-left: 16px;
`

const SubmitButton = styled(Button)`
  width: 100%;
  opacity: ${ props => props.disabled && '0.4' };
  border: none;

  @media ${ device.sm } {
    margin-top: 2rem;
  }
`

const HoneyPot = styled.div`
  visibility:hidden;
  opacity: 0;
  display: none;
`

const SuccessContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`

const SuccessContainerInner = styled.div`
  width: 100%;
  max-width: 500px;
  font-size: .875rem;
  letter-spacing: 0.53px;
  line-height: 1.85;

  h2 {
    margin-bottom: 2rem;
  }

  > div {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

class Form extends Component {
  constructor (props) {
    super(props)

    this.state = {
      calendarVisible: false,
      selectedDate: '',
      roomAvailability: {},
      disbled: true,
      privacy: false,
      successView: false,

      name: '',
      firma: '',
      email: '',
      telefon: '',
      anzahl: '',
      raum: '',
      anlass: '',
      budget: '',
      details: '',
      inselgarten: '',
      sonnendeck: '',
      brueckendeck: '',
      theaterdeck: '',
      showError: false
      // showError: {
      //   name: false,
      //   email: false,
      //   telefon: false,
      //   anzahl: false,
      //   anlass: false,
      //   budget: false,
      //   privacy: false,
      // }
    }
  }

  toggleCalendar = () => {
    this.setState(state => {
      return {
        calendarVisible: !state.calendarVisible
      }
    })
  }

  onSelectDate = (selectedDate, roomAvailability) => {
    this.setState({
      selectedDate: getFullDate(selectedDate),
      calendarVisible: false,
      roomAvailability
    })
  }

  validate = () => {
    const valid = this.state.privacy && this.state.name !== '' && this.state.email !== '' && validateEmail(this.state.email) && this.state.telefon !== '' && this.state.anzahl !== '' && this.state.anlass !== '' && this.state.budget !== ''

    if (!valid) {
      this.setState({
        showError: true
      })
    }

    return valid
  }

  handleSubmit = e => {
    e.preventDefault()

    if (this.validate()) {
      this.setState({
        feedbackMessage: ''
      }, () => {
        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({
            'form-name': 'Mietanfrage',
            Name: this.state.name,
            Firma: this.state.firma,
            Email: this.state.email,
            Telefon: this.state.telefon,
            Anzahl: this.state.anzahl,
            Datum: this.state.selectedDate,
            Raum: [
              this.state.inselgarten && 'wiese',
              this.state.brueckendeck && 'brueckendeck',
              this.state.theaterdeck && 'theaterdeck',
              this.state.sonnendeck && 'sonnendeck',
            ].filter(room => room !== '').join(','),
            Anlass: this.state.anlass,
            Budget: this.state.budget,
            Details: this.state.details
          })
        })
          .then(() => {
            this.setState({
              successView: true
            })
            // this.setState({
            //   feedbackMessage: 'Thank you for your inquiry',
            //   email: '',
            //   message: ''
            // })

            // this.props.resetCalendar()
          })
        // .catch(error => {
        //   this.setState({
        //     feedbackMessage: error
        //   })
        // })
      })
    }
  };

  handleChange = e => {
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name.toLowerCase()]: e.target.checked })
    } else {
      this.setState({ [e.target.name.toLowerCase()]: e.target.value })
    }
  };

  render () {
    const {
      calendarVisible,
      selectedDate,
      roomAvailability,
      name,
      firma,
      email,
      telefon,
      anzahl,
      anlass,
      budget,
      details,
      inselgarten,
      sonnendeck,
      brueckendeck,
      theaterdeck,
      disabled,
      privacy,
      successView,
      showError
    } = this.state

    const {
      calendarLimit
    } = this.props

    const formEnabled = privacy && name !== '' && email !== '' && validateEmail(email) && telefon !== '' && anzahl !== '' && anlass !== '' && budget !== ''

    return (
      <Container>
        {!successView &&
          <Row>
            <Col xs={12} md={12} lgOffset={1} lg={10}>
              <Row>
                <Col xs={12}><h2>Mietanfrage</h2></Col>
              </Row>
              <Row>
                <Instructions xs={12} sm={6}>
                  Bitte füllen Sie für Ihre Mietanfrage das folgende Formular aus. Zwischen Mai und September sind Veranstaltungen ab 100 Gästen möglich. Zwischen Oktober und April können Veranstaltungen bereits ab 50 Personen gebucht werden.
                </Instructions>
                <Instructions xs={12} sm={6}>
                  Wir empfehlen gern Cateringunternehmen, die unser Gelände gut kennen. Getränke werden grundsätzlich über die Insel Berlin konsumiert.
                </Instructions>
              </Row>
              <form
                name="Mietanfrage"
                method="post"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
                noValidate
              >
                <Row>
                  <GroupHeader xs={12}>Persönliche Daten</GroupHeader>
                </Row>
                <InputGroup>
                  <Col xs={12} sm={3}>
                    <TextInput
                      type="text"
                      placeholder="Name*"
                      name="Name"
                      value={name}
                      fieldRequired={true}
                      onChange={this.handleChange}
                    />
                    {showError && name === '' &&
                      <ErrorMessage>
                        Bitte ausfüllen
                      </ErrorMessage>
                    }
                  </Col>
                  <Col xs={12} sm={3}>
                    <TextInput
                      type="text"
                      placeholder="Firma"
                      name="Firma"
                      value={firma}
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={3}>
                    <TextInput
                      type="email"
                      placeholder="E-Mail*"
                      name="Email"
                      value={email}
                      fieldRequired={true}
                      onChange={this.handleChange}
                    />
                    {showError && email === '' &&
                      <ErrorMessage>
                        Bitte ausfüllen
                      </ErrorMessage>
                    }
                    {showError && email !== '' && !validateEmail(email) &&
                      <ErrorMessage>
                        Ihrer E-Mail-Adresse ist nicht gültig
                      </ErrorMessage>
                    }
                  </Col>
                  <Col xs={12} sm={3}>
                    <TextInput
                      type="tel"
                      placeholder="Telefon*"
                      name="Telefon"
                      value={telefon}
                      fieldRequired={true}
                      onChange={this.handleChange}
                    />
                    {showError && telefon === '' &&
                      <ErrorMessage>
                        Bitte ausfüllen
                      </ErrorMessage>
                    }
                  </Col>
                </InputGroup>
                <Row>
                  <GroupHeader xs={12}>
                    Gäste Daten
                  </GroupHeader>
                </Row>
                <InputGroup horizontal>
                  <Col xs={6} sm={3}>
                    <Dropdown
                      placeholder="Anzahl (ca.)*"
                      type="capacity"
                      name="Anzahl"
                      value={anzahl}
                      fieldRequired={true}
                      onChange={this.handleChange}
                      error={showError && anzahl === ''}
                    />
                    {showError && anzahl === '' &&
                      <ErrorMessage>
                        Bitte ausfüllen
                      </ErrorMessage>
                    }
                  </Col>
                </InputGroup>
                {/* <Row>
            <GroupHeader xs={12} smOffset={2} sm={4}></GroupHeader>
            <GroupHeader xs={12} sm={4}>Details</GroupHeader>
          </Row> */}
                <Row>
                  <Col xs={12} sm={6}>
                    <VerticalGroupHeader>Veranstaltungs Daten</VerticalGroupHeader>
                    <VerticalInputGroup>
                      <DateInput>
                        <TextInput
                          type="text"
                          placeholder="Datum"
                          name="Datum"
                          readOnly
                          value={selectedDate}
                          onChange={this.handleChange}
                          onClick={this.toggleCalendar}
                        />
                        <CalendarContainer calendarVisible={calendarVisible}>
                          <Overlay onClick={this.toggleCalendar}/>
                          <CalendarContainerInner>
                            <FormCalendar onSelectDate={this.onSelectDate} calendarLimit={calendarLimit}/>
                          </CalendarContainerInner>
                        </CalendarContainer>
                      </DateInput>
                      <FormRooms
                        roomAvailability={roomAvailability}
                        onChange={this.handleChange}
                        inselgarten={inselgarten}
                        sonnendeck={sonnendeck}
                        brueckendeck={brueckendeck}
                        theaterdeck={theaterdeck}
                      />
                      <div>
                        <Dropdown
                          placeholder="Anlass*"
                          type="occasion"
                          name="Anlass"
                          value={anlass}
                          fieldRequired={true}
                          onChange={this.handleChange}
                          error={showError && anlass === ''}
                        />
                        {showError && anlass === '' &&
                          <ErrorMessage>
                            Bitte ausfüllen
                          </ErrorMessage>
                        }
                      </div>
                      <div>
                        <Dropdown
                          placeholder="Budget*"
                          type="budget"
                          name="Budget"
                          value={budget}
                          fieldRequired={true}
                          onChange={this.handleChange}
                          error={showError && budget === ''}
                        />
                        {showError && budget === '' &&
                          <ErrorMessage>
                            Bitte ausfüllen
                          </ErrorMessage>
                        }
                      </div>
                    </VerticalInputGroup>
                  </Col>
                  <DetailsContainer xs={12} sm={6}>
                    <VerticalGroupHeader>Details</VerticalGroupHeader>
                    <Details
                      placeholder="z.B. Ablauf, Anforderungen, besondere Wünsche"
                      name="Details"
                      value={details}
                      onChange={this.handleChange}
                    />
                  </DetailsContainer>
                </Row>

                <input
                  type="hidden"
                  name="form-name"
                  value="Mietanfrage"
                  readOnly
                />
                <HoneyPot>
                  <input name="bot-field" onChange={this.handleChange}/>
                </HoneyPot>
                <input
                  type="hidden"
                  name="Raum"
                  value={[
                    inselgarten && 'wiese',
                    brueckendeck && 'brueckendeck',
                    theaterdeck && 'theaterdeck',
                    sonnendeck && 'sonnendeck',
                  ].filter(room => room !== '').join(',')}
                />
                <FormFooter>
                  <Col xs={12} sm={6}>
                    <ul>
                      <Checkbox showError={showError}>
                        <input
                          type="checkbox"
                          value="form-privacy-policy"
                          id="form-privacy-policy"
                          name="privacy"
                          checked={privacy}
                          onChange={this.handleChange}
                          required
                        />
                        <label htmlFor="form-privacy-policy">Ich stimme den <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> zu.</label>
                        {showError && !privacy &&
                          <ErrorMessage>
                            Bitte ausfüllen
                          </ErrorMessage>
                        }
                      </Checkbox>
                    </ul>
                    <RequiredField>* Pflichtfelder</RequiredField>
                  </Col>
                  <Col xs={12} smOffset={2} sm={4}>
                    <SubmitButton submitDisabled={!formEnabled} type="submit">Senden</SubmitButton>
                  </Col>
                </FormFooter>
              </form>
            </Col>
          </Row>
        }
        {successView &&
          <SuccessContainer>
            <SuccessContainerInner>
              <h2>Mietfrage war erfolgreich</h2>
              <div>
                Vielen Dank für deine Anfrage! Eine Kopie hast du auf deine  E-Mail {email} erhalten.
              </div>
              <div>
                Wir werden deine Mietanfrage bearbeiten und uns bei dir melden. Es kann bis zu ein paar Tagen dauern.Bitte habe Geduld.
              </div>
              <div>
                Bis bald,
                dein Insel Team
              </div>
            </SuccessContainerInner>
          </SuccessContainer>
        }
      </Container>
    )
  }
}

function validateEmail (email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function encode (data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default Form
